// Lista CSU (Adnéia, 03/11/2026): os chamados que a CSU transferiu à WeConnect, que o analista
// importa como a Lista LL. A regra de quem abre atendimento fica no backend (routes/lista_csu.py);
// aqui só o que a janela mostra. Situação, resumo, motivo e quem importa são os da Lista LL (listaLL.js).

// A cor da prioridade da CSU: o que ela marca como mais grave salta aos olhos.
const CORES_PRIORIDADE = {
  critico: 'text-red-700 dark:text-red-400 font-semibold',
  alto: 'text-orange-700 dark:text-orange-400 font-semibold',
  medio: 'text-slate-700 dark:text-slate-300',
  baixo: 'text-slate-500 dark:text-slate-400',
};

function chave(texto) {
  return String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

export function corPrioridade(prioridade) {
  return CORES_PRIORIDADE[chave(prioridade)] || '';
}

// "31/10/2026" (como a lista grava a abertura na CSU) → quantos dias corridos até hoje; sem data, null.
export function diasAberto(abertoEm, agora = new Date()) {
  const m = String(abertoEm || '').match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (!m) return null;
  const aberto = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
  return Math.max(0, Math.round((hoje - aberto) / 86400000));
}
